
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["drmicon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.697 1.595L6.707.264l-5.99 1.33a.73.73 0 00-.571.712v7.281c0 1.462.73 2.828 1.948 3.639L6.707 16.3l4.613-3.075a4.373 4.373 0 001.948-3.64v-7.28a.73.73 0 00-.571-.711z","fill":"#0A2144"}}),_c('path',{attrs:{"d":"M6.532 10.846l4.371-4.371-1.055-1.056L6.16 9.106 4.055 7 2.998 8.055l3.156 3.156.371-.37.006.005z","fill":"#fff"}})])
          )
        }
      }
    